module.exports = __webpack_public_path__ + "img/1.151c4b5f.png";